import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { KaykoLogo } from './KaykoLogo';
import { SmartLink } from './SmartLink';
import { footerColumns } from '../data/content';
const footerHrefs: Record<string, string> = {
  'Point of Sale': '/products/sales-pos',
  Inventory: '/products/inventory',
  Expenses: '/products/expenses',
  Purchases: '/products/purchases',
  'Customer credit': '/products/customers',
  'Reports & insights': '/products/reports',
  'Business financing': '/products/business-finance',
  Retail: '/solutions/retail',
  'Food & Beverage': '/solutions/food-beverage',
  Manufacturing: '/solutions/manufacturing',
  Services: '/solutions/services',
  Hospitality: '/solutions/hospitality',
  Healthcare: '/solutions/healthcare',
  'About Kayko': '/about',
  'Customer stories': '/customers',
  Careers: '/careers',
  'Guides & insights': '/blog',
  Contact: '/contact',
  'Data protection': '/security',
  'Terms of service': '/legal/terms',
  'Privacy policy': '/legal/privacy',
  'Cookie policy': '/legal/cookies'
};
const socials = [{
  Icon: LinkedinIcon,
  label: 'Kayko on LinkedIn'
}, {
  Icon: InstagramIcon,
  label: 'Kayko on Instagram'
}, {
  Icon: FacebookIcon,
  label: 'Kayko on Facebook'
}, {
  Icon: TwitterIcon,
  label: 'Kayko on X'
}, {
  Icon: YoutubeIcon,
  label: 'Kayko on YouTube'
}];
function AppleLogo() {
  return <svg viewBox="0 0 384 512" className="h-[22px] w-[22px] fill-white" aria-hidden="true" data-id="element-1453" data-mp="1oiea13fm7rfn">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" data-id="element-1454" data-mp="1tgplfilk69zz" />
    </svg>;
}
function GooglePlayLogo() {
  return <svg viewBox="0 0 512 512" className="h-[20px] w-[20px]" aria-hidden="true" data-id="element-1455" data-mp="2m1v07zrqnm04">
      <path fill="#00d7fe" d="M48 32 272 256 48 480c-9-5-16-15-16-28V60c0-13 7-23 16-28z" data-id="element-1456" data-mp="2h3l3vlua2fcx" />
      <path fill="#00f076" d="M48 32c6-3 14-4 22 0l272 155-70 69z" data-id="element-1457" data-mp="2d1q2yig9e3zo" />
      <path fill="#ff3a44" d="M48 480 272 256l70 69L70 480c-8 4-16 3-22 0z" data-id="element-1458" data-mp="2d42iyq2gi4a3" />
      <path fill="#ffd500" d="m342 187 86 49c21 12 21 28 0 40l-86 49-70-69z" data-id="element-1459" data-mp="282vbyt85194h" />
    </svg>;
}
const stores = [{
  eyebrow: 'Download on the',
  name: 'App Store',
  Logo: AppleLogo
}, {
  eyebrow: 'Get it on',
  name: 'Google Play',
  Logo: GooglePlayLogo
}];
export function SiteFooter() {
  return <footer data-nav-theme="dark" className="footer-gradient w-full border-t border-white/20 pb-12 pt-16 text-white" data-id="element-1460" data-mp="1teicvndr7a5r">
      <div className="mx-auto max-w-shell px-6" data-id="element-1461" data-mp="1pau3r09h46ie">
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:grid-cols-[200px_repeat(5,minmax(0,1fr))]" data-id="element-1462" data-mp="1kcitiof9ntzn">
          <div className="col-span-2 sm:col-span-3 lg:col-span-1" data-id="element-1463" data-mp="1ffsdu27dj0er">
            <KaykoLogo tone="light" data-id="element-1464" data-mp="3r2cejxa6r6sj" />
          </div>

          {footerColumns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-1465" data-mp="3w0e8jd95gqis">
              <h2 className="text-[14px] font-semibold text-white" data-id="element-1466" data-mp="3w2qo5jrfqoso">{column.heading}</h2>
              <ul className="mt-4 space-y-2.5" data-id="element-1467" data-mp="4si89e6vrin9">
                {column.links.map(link => <li key={link} data-id="element-1468" data-mp="8vet7bjw7qud">
                    <SmartLink href={footerHrefs[link]} className="text-[14px] text-white/60 transition-colors duration-150 ease-out hover:text-white" data-id="element-1469" data-mp="38blb1ccvqam2">
                      {link}
                    </SmartLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-14 flex flex-col gap-8 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-1470" data-mp="3m4kq5d8r22t3">
          <ul className="flex items-center gap-5" data-id="element-1471" data-mp="2tlx5fyxo0psj">
            {socials.map(({
            Icon,
            label
          }) => <li key={label} data-id="element-1472" data-mp="2ahafzurlysuu">
                <a href="#" aria-label={label} className="text-white/60 transition-colors duration-150 ease-out hover:text-white" data-id="element-1473" data-mp="2aibuk97u1xhb">
                  <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-1474" data-mp="2k96hlfswl13t" />
                </a>
              </li>)}
          </ul>

          <div className="flex flex-wrap items-center gap-3" data-id="element-1475" data-mp="2t8bj8uzrhak7">
            {stores.map(({
            eyebrow,
            name,
            Logo
          }) => <a key={name} href="#" aria-label={`${eyebrow} ${name}`} className="flex h-[46px] items-center gap-2.5 rounded-[9px] border border-white/30 bg-black px-3.5 transition-colors duration-150 ease-out hover:border-white/70" data-id="element-1476" data-mp="2o9qi8tcoqmup">
                <Logo data-id="element-1477" data-mp="18thtgl3wxw1f" />
                <span className="flex flex-col leading-tight" data-id="element-1478" data-mp="18szyrswwfpvm">
                  <span className="text-[10px] text-white/75" data-id="element-1479" data-mp="13u5awck2rb4n">{eyebrow}</span>
                  <span className="whitespace-nowrap text-[16px] font-semibold tracking-[-0.01em] text-white" data-id="element-1480" data-mp="3fgz0tt03xkn2">{name}</span>
                </span>
              </a>)}
          </div>
        </div>

        <div className="mt-10 space-y-3 text-[12px] leading-[1.7] text-white/55" data-id="element-1481" data-mp="35r75uxo3ipi2">
          <p className="max-w-[820px]" data-id="element-1482" data-mp="3aq0iknvk6ch6">
            Kayko provides business-management software and access to financial services through
            appropriately licensed entities and partners. Financing is subject to eligibility,
            assessment, and applicable terms.
          </p>
          <p data-id="element-1483" data-mp="30phs3a9hnxqa">Copyright © 2026 KAYKO Group Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}